import Axios from 'axios';
import _ from 'lodash';
import { drawProfilePicture } from '../../../common/functions';

// Action Types
export const FETCH_PROFILE_PICTURE_SUCCESS = 'FETCH_PROFILE_PICTURE_SUCCESS';
export const FETCH_PROFILE_PICTURE_DSO_DOCTOR_SUCCESS = 'FETCH_PROFILE_PICTURE_DSO_DOCTOR_SUCCESS';
export const FETCH_PROFILE_PICTURE_PENDING = 'FETCH_PROFILE_PICTURE_PENDING';
export const FETCH_PROFILE_PICTURE_ERROR = 'FETCH_PROFILE_PICTURE_ERROR';
export const SET_PROFILE_METADATA_EDIT = 'SET_PROFILE_METADATA_EDIT';
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE;';
export const OPEN_UPLOAD_PICTURE_MODAL = 'OPEN_UPLOAD_PICTURE_MODAL';
export const CLOSE_UPLOAD_PICTURE_MODAL = 'CLOSE_UPLOAD_PICTURE_MODAL';
export const SAVE_PROFILE_PICTURE_REPOSITION_PENDING = 'SAVE_PROFILE_PICTURE_REPOSITION_PENDING';
export const SAVE_PROFILE_PICTURE_REPOSITION_SUCCESS = 'SAVE_PROFILE_PICTURE_REPOSITION_SUCCESS';
export const SAVE_PROFILE_PICTURE_DSO_DOCTOR_REPOSITION_SUCCESS = 'SAVE_PROFILE_PICTURE_DSO_DOCTOR_REPOSITION_SUCCESS';
export const SAVE_PROFILE_PICTURE_REPOSITION_ERROR = 'SAVE_PROFILE_PICTURE_REPOSITION_ERROR';
export const OPEN_REPOSITION_PROFILE_PICTURE_MODAL = 'OPEN_REPOSITION_PROFILE_PICTURE_MODAL';
export const OPEN_REPOSITION_PROFILE_PICTURE_DSO_DOCTOR_MODAL = 'OPEN_REPOSITION_PROFILE_PICTURE_DSO_DOCTOR_MODAL';
export const CLOSE_REPOSITION_PROFILE_PICTURE_MODAL = 'CLOSE_REPOSITION_PROFILE_PICTURE_MODAL';
export const OPEN_PROFILE_PICTURE_MENU = 'OPEN_PROFILE_PICTURE_MENU';
export const CLOSE_PROFILE_PICTURE_MENU = 'CLOSE_PROFILE_PICTURE_MENU';
export const OPEN_DELETE_PICTURE_MODAL = 'OPEN_DELETE_PICTURE_MODAL';
export const CLOSE_DELETE_PICTURE_MODAL = 'CLOSE_DELETE_PICTURE_MODAL';
export const DELETE_PROFILE_PICTURE_PENDING = 'DELETE_PROFILE_PICTURE_PENDING';
export const DELETE_PROFILE_PICTURE_SUCCESS = 'DELETE_PROFILE_PICTURE_SUCCESS';
export const DELETE_PROFILE_PICTURE_ERROR = 'DELETE_PROFILE_PICTURE_ERROR';
export const UPLOAD_PROFILE_PICTURE_PENDING = 'UPLOAD_PROFILE_PICTURE_PENDING';
export const UPLOAD_PROFILE_PICTURE_SUCCESS = 'UPLOAD_PROFILE_PICTURE_SUCCESS';
export const UPLOAD_PROFILE_PICTURE_ERROR = 'UPLOAD_PROFILE_PICTURE_ERROR';
export const INVALID_PROFILE_PICTURE_SIZE = 'INVALID_PROFILE_PICTURE_SIZE';
export const INVALID_PROFILE_PICTURE_FORMAT_ERROR = 'INVALID_PROFILE_PICTURE_FORMAT_ERROR';
export const FETCH_ACCOUNT_SETTINGS_PENDING = 'FETCH_ACCOUNT_SETTINGS_PENDING';
export const FETCH_ACCOUNT_SETTINGS_SUCCESS = 'FETCH_ACCOUNT_SETTINGS_SUCCESS';
export const FETCH_ACCOUNT_SETTINGS_ERROR = 'FETCH_ACCOUNT_SETTINGS_ERROR';

// Action Creators
// -----------------------------------------------------------------------------

/**
 * Retrieves doctor's profile picture info
 *
 * @function
 * @param {number} doctor_id - Doctor id
 */
export function fetchAccountSettings(doctor_id) {
  return (dispatch) => {
    dispatch(fetchAccountSettingsPending());

    Axios.get(`/apiV2/account_setting/${doctor_id}`)
      .then(function (result) {
        dispatch(fetchAccountSettingsSuccess(result.data));
      })
      .catch(function (err) {
        dispatch(fetchAccountSettingsError());
      });
  };
}

export function fetchAccountSettingsPending() {
  return {
    type: FETCH_ACCOUNT_SETTINGS_PENDING,
  };
}

export function fetchAccountSettingsSuccess(account) {
  return {
    type: FETCH_ACCOUNT_SETTINGS_SUCCESS,
    account: account,
  };
}

export function fetchAccountSettingsError() {
  return {
    type: FETCH_ACCOUNT_SETTINGS_ERROR,
  };
}

/**
 * Retrieves doctor's profile picture info
 *
 * @function
 * @param {number} doctor_id - Doctor id
 * @param {boolean} open_reposition_modal - Indicating if the reposition modal should be opened after fetching profile picture
 * @param {object} that - Instance of class
 */
export function fetchProfilePicture(doctor_id, is_edit_dso_doctor_account_page, open_reposition_modal, that) {
  return (dispatch) => {
    dispatch(fetchProfilePicturePending());

    Axios.get(`/apiv3/doctor/${doctor_id}/profilepicture`)
      .then(function (result) {
        if (is_edit_dso_doctor_account_page) {
          dispatch(
            fetchProfilePictureDsoDoctorSuccess(result.data.presigned_url, result.data.profile_metadata, result.data.s3_url_raw, result.data.s3_url_thumbnail)
          );
        } else {
          dispatch(fetchProfilePictureSuccess(result.data.presigned_url, result.data.profile_metadata, result.data.s3_url_raw, result.data.s3_url_thumbnail));
        }
        if (open_reposition_modal) {
          dispatch(openRepositionProfilePictureModal());
        }
        drawProfilePicture(that, is_edit_dso_doctor_account_page);
      })
      .catch(function (err) {
        dispatch(fetchProfilePictureError());
      });
  };
}

export function fetchProfilePicturePending() {
  return {
    type: FETCH_PROFILE_PICTURE_PENDING,
  };
}

export function fetchProfilePictureDsoDoctorSuccess(profile_image, profile_metadata, s3_url_raw, s3_url_thumbnail) {
  return {
    type: FETCH_PROFILE_PICTURE_DSO_DOCTOR_SUCCESS,
    profile_image_dso_doctor: profile_image,
    profile_metadata_dso_doctor: profile_metadata,
    s3_url_raw: s3_url_raw,
    s3_url_thumbnail: s3_url_thumbnail,
  };
}

export function fetchProfilePictureSuccess(profile_image, profile_metadata, s3_url_raw, s3_url_thumbnail) {
  return {
    type: FETCH_PROFILE_PICTURE_SUCCESS,
    profile_image: profile_image,
    profile_metadata: profile_metadata,
    s3_url_raw: s3_url_raw,
    s3_url_thumbnail: s3_url_thumbnail,
  };
}

export function fetchProfilePictureError() {
  return {
    type: FETCH_PROFILE_PICTURE_ERROR,
  };
}

/**
 * Saves the reposition info for the profile picture
 *
 * @function
 * @param {number} doctor_id - Doctor id
 * @param {object} that - Instance of class
 */
export function saveProfilePictureReposition(doctor_id, that) {
  return (dispatch, getState) => {
    dispatch(saveProfilePictureRepositionPending());

    const { profile_metadata_edit, s3_url_raw, s3_url_thumbnail } = getState().accountSettingsReducer;
    const data = _.cloneDeep(profile_metadata_edit);
    data.s3_url_raw = s3_url_raw;
    data.s3_url_thumbnail = s3_url_thumbnail;

    Axios.put(`/apiv3/doctor/${doctor_id}/profilepicture`, data)
      .then(function (result) {
        if (that.props.is_edit_dso_doctor_account_page) {
          dispatch(saveProfilePictureDsoDoctorRepositionSuccess());
        } else {
          dispatch(saveProfilePictureRepositionSuccess());
        }
        drawProfilePicture(that, that.props.is_edit_dso_doctor_account_page);
      })
      .catch(function (err) {
        dispatch(saveProfilePictureRepositionError());
      });
  };
}

export function saveProfilePictureRepositionPending() {
  return {
    type: SAVE_PROFILE_PICTURE_REPOSITION_PENDING,
  };
}

export function saveProfilePictureRepositionSuccess() {
  return {
    type: SAVE_PROFILE_PICTURE_REPOSITION_SUCCESS,
  };
}

export function saveProfilePictureDsoDoctorRepositionSuccess() {
  return {
    type: SAVE_PROFILE_PICTURE_DSO_DOCTOR_REPOSITION_SUCCESS,
  };
}

export function saveProfilePictureRepositionError() {
  return {
    type: SAVE_PROFILE_PICTURE_REPOSITION_ERROR,
  };
}

/**
 * Handles the event when the user drags the profile picture circle when repositioning
 *
 * @function
 * @param {number} x - X coordinate of the image
 * @param {number} y - Y coordinate of the image
 * @param {number} width - Width of the cropped image
 * @param {number} height - Height of the cropped image
 * @return {object} - Action type with profile metadata
 */
export function setProfileMetadataEdit(x, y, width, height) {
  return (dispatch, getState) => {
    const { profile_metadata_edit } = getState().accountSettingsReducer;
    let profile_metadata_edit_updates = _.cloneDeep(profile_metadata_edit);

    if (profile_metadata_edit_updates) {
      profile_metadata_edit_updates.x = x;
      profile_metadata_edit_updates.y = y;
      profile_metadata_edit_updates.width = width;
      profile_metadata_edit_updates.height = height;
    } else {
      profile_metadata_edit_updates = {
        x: x,
        y: y,
        width: width,
        height: height,
      };
    }

    dispatch({
      type: SET_PROFILE_METADATA_EDIT,
      profile_metadata_edit: profile_metadata_edit_updates,
    });
  };
}

export function setProfileImage(profile_image) {
  return {
    type: SET_PROFILE_IMAGE,
    profile_image: profile_image,
  };
}

/**
 * Handles when user deletes their profile picture
 *
 * @function
 * @param {number} doctor_id - Doctor id
 * @param {object} that - Instance of class
 */
export function onDeleteProfilePicture(doctor_id, that) {
  return (dispatch) => {
    dispatch(deleteProfilePicturePending());
    Axios.delete(`/apiv3/doctor/${doctor_id}/profilepicture`)
      .then((res) => {
        const open_reposition_modal = false;
        dispatch(fetchProfilePicture(doctor_id, that.props.is_edit_dso_doctor_account_page, open_reposition_modal, that));
        dispatch(deleteProfilePictureSuccess());
      })
      .catch(function (err) {
        dispatch(deleteProfilePictureError());
      });
  };
}

export function deleteProfilePicturePending() {
  return {
    type: DELETE_PROFILE_PICTURE_PENDING,
  };
}

export function deleteProfilePictureSuccess() {
  return {
    type: DELETE_PROFILE_PICTURE_SUCCESS,
  };
}

export function deleteProfilePictureError() {
  return {
    type: DELETE_PROFILE_PICTURE_ERROR,
  };
}

/**
 * Handles event when user selects a profile picture to upload
 *
 * @function
 * @param {object} e - Event object
 * @param {number} doctor_id - Doctor id
 */
export function onProfilePictureUpload(e, doctor_id, that) {
  return (dispatch) => {
    dispatch(uploadProfilePicturePending());
    let formData = new FormData();
    const max_image_dimension = 500;
    formData.append('file', e.target.files[0]);
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = function (event) {
        let img = new Image();
        img.onload = function () {
          if (img.width > max_image_dimension && img.height > max_image_dimension) {
            Axios.post(`/apiv3/doctor/${doctor_id}/profilepicture`, formData)
              .then((res) => {
                dispatch(uploadProfilePictureSuccess(res.data.s3_url_raw, res.data.s3_url_thumbnail, res.data.presigned_url_raw));
                that.inputReference.current.value = '';
              })
              .catch(function (err) {
                dispatch(uploadProfilePictureError(err));
                that.inputReference.current.value = '';
              });
          } else {
            dispatch(uploadProfilePictureErrorSize());
            that.inputReference.current.value = '';
          }
        };
        if (reader.result.includes('image/jpg') || reader.result.includes('image/jpeg') || reader.result.includes('image/png')) {
          img.src = reader.result;
        } else {
          dispatch(unSupportedFileTypeError());
          that.inputReference.current.value = '';
        }
      };
    }
  };
}

export function uploadProfilePicturePending() {
  return {
    type: UPLOAD_PROFILE_PICTURE_PENDING,
  };
}

export function uploadProfilePictureSuccess(s3_url_raw, s3_url_thumbnail, presigned_url_raw) {
  return {
    type: UPLOAD_PROFILE_PICTURE_SUCCESS,
    profile_image_edit: presigned_url_raw,
    s3_url_raw: s3_url_raw,
    s3_url_thumbnail: s3_url_thumbnail,
  };
}

export function uploadProfilePictureError(err) {
  if (err.response.status === 400 && err.response.data === 'Invalid format') {
    return {
      type: INVALID_PROFILE_PICTURE_FORMAT_ERROR,
    };
  }
  return {
    type: UPLOAD_PROFILE_PICTURE_ERROR,
  };
}

export function unSupportedFileTypeError() {
  return {
    type: INVALID_PROFILE_PICTURE_FORMAT_ERROR,
  };
}
/**
 * Handles event when user selects a profile picture to upload which is smaller than required dimension
 *
 * @function
 * @return {object} - Returns redux action type
 */
export function uploadProfilePictureErrorSize() {
  return {
    type: INVALID_PROFILE_PICTURE_SIZE,
  };
}

// Modals and Menus
export function openUploadPictureModal() {
  return {
    type: OPEN_UPLOAD_PICTURE_MODAL,
  };
}

export function closeUploadPictureModal() {
  return {
    type: CLOSE_UPLOAD_PICTURE_MODAL,
  };
}

export function openRepositionProfilePictureModal() {
  return {
    type: OPEN_REPOSITION_PROFILE_PICTURE_MODAL,
  };
}

export function openRepositionProfilePictureDsoDoctorModal() {
  return {
    type: OPEN_REPOSITION_PROFILE_PICTURE_DSO_DOCTOR_MODAL,
  };
}

/**
 * Close the reposition modal and retrieve last saved profile image and metadata
 *
 * @function
 * @param {number} doctor_id - Doctor id
 * @param {object} that - Instance of class
 */
export function closeRepositionProfilePictureModal(doctor_id, that) {
  return (dispatch) => {
    dispatch(fetchProfilePicturePending());

    Axios.get(`/apiv3/doctor/${doctor_id}/profilepicture`)
      .then(function (result) {
        if (that.props.is_edit_dso_doctor_account_page) {
          dispatch(
            fetchProfilePictureDsoDoctorSuccess(result.data.presigned_url, result.data.profile_metadata, result.data.s3_url_raw, result.data.s3_url_thumbnail)
          );
        } else {
          dispatch(fetchProfilePictureSuccess(result.data.presigned_url, result.data.profile_metadata, result.data.s3_url_raw, result.data.s3_url_thumbnail));
        }

        if (result.data.presigned_url) {
          drawProfilePicture(that, that.props.is_edit_dso_doctor_account_page);
        }

        dispatch({
          type: CLOSE_REPOSITION_PROFILE_PICTURE_MODAL,
        });
      })
      .catch(function (err) {
        dispatch(fetchProfilePictureError());
      });
  };
}

export function openProfilePictureMenu() {
  return {
    type: OPEN_PROFILE_PICTURE_MENU,
  };
}

export function closeProfilePictureMenu() {
  return {
    type: CLOSE_PROFILE_PICTURE_MENU,
  };
}

export function openDeletePictureModal(that) {
  return (dispatch) => {
    dispatch({
      type: OPEN_DELETE_PICTURE_MODAL,
    });
    drawProfilePicture(that, that.props.is_edit_dso_doctor_account_page);
  };
}

export function closeDeletePictureModal() {
  return {
    type: CLOSE_DELETE_PICTURE_MODAL,
  };
}
